import React from 'react';
import moment from "moment";
import { Link } from "react-router-dom";
import { hasETACrossed } from './helper';
import { DATE_FORMAT } from '../../constants';
export const PENDING = 'PENDING';
export const COMPLETED = 'COMPLETED';
export const DEFAULT_PAGE_SIZE = 10;
export const pendingTableColumns = [
    {
        Header: "Company Name",
        id: "companyName",
        accessor: d => <Link id={d.caseId} to={`/my-tasks/taskdetails/${d.caseId}`} title={d.caseId} className="text-truncate">{d.companyName}</Link>,
        maxWidth: 300
    },
    {
        Header: "Address",
        id: "address",
        accessor: d => <div title={d.address} className="text-truncate">{d.address}</div>,
        className: 'center'
    },
    {
        Header: "Placed on",
        id: "placedOn",
        accessor: p => <div title={p.placedOn}>{moment(p.placedOn).format(DATE_FORMAT)}</div>,
        maxWidth: 100
    },
    {
        Header: "Pendency",
        id: "deliveryDate",
        accessor: p => <div className={hasETACrossed(p.deliveryDate) === true ? "red_text" : "green_text"}>{moment(p.deliveryDate).diff(moment(), 'days')} days</div>,
        maxWidth: 100
    }
];

export const completedTableColumns = [
    {
        Header: "Company Name",
        id: "companyName",
        accessor: d => <Link id={d.caseId} to={`/my-tasks/taskdetails/${d.caseId}`} title={d.caseId} className="text-truncate">{d.companyName}</Link>,
        maxWidth: 300
    },
    {
        Header: "Address",
        id: "address",
        accessor: d => <div title={d.address} className="text-truncate">{d.address}</div>,
        className: 'center'
    },
    {
        Header: "Placed on",
        id: "placedOn",
        accessor: p => <div title={p.placedOn}>{moment(p.placedOn).format(DATE_FORMAT)}</div>,
        maxWidth: 100
    },
    {
        Header: "Completed on",
        id: "overallCompletedDate",
        accessor: p => <div className={hasETACrossed(p.overallCompletedDate) === true ? "red_text" : "green_text"}>{moment(p.overallCompletedDate).format(DATE_FORMAT)}</div>,
        maxWidth: 120
    }
]